import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted, ref } from 'vue'
import TabsContacts from '@/components/TabsContacts/index.vue'
import baseMessage from '@/views/overseasSales/customerCenter/components/baseMessage.vue'
import { potentialDetail } from '@/api/overseasSales/customerCenter'
import { useRoute } from 'vue-router'

const __default__ = {
  name: 'FbuClientsView'
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  type: {
    type: String
  }
},
  setup(__props) {


const route = useRoute()
const data = ref({})
const loading = ref(false)
// 获取详情
const fetch = () => {
  if (route.query.cosId) {
    loading.value = true
    potentialDetail(route.query.cosId)
      .then((res) => {
        data.value = res.data
      })
      .finally(() => {
        loading.value = false
      })
  }
}
// 标签页切换
const changeTabs = (v: string) => {
  if (v === '1') {
    fetch()
  }
}
onMounted(() => {
  fetch()
})

return (_ctx: any,_cache: any) => {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_CosViewContent = _resolveComponent("CosViewContent")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_CosViewContent, {
            header: "",
            title: data.value?.customerInfo?.customerName,
            sellerName: data.value?.customerInfo?.sellerName,
            customLabel: _ctx.$t('common.contactName'),
            customValue: data.value?.contact?.name
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_tabs, { onChange: changeTabs }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_tab_pane, {
                    key: "1",
                    tab: _ctx.$t('common.baseTabs')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(baseMessage, {
                        disabled: true,
                        formItemView: "",
                        data: data.value,
                        type: __props.type,
                        hideOk: true
                      }, null, 8, ["data", "type"])
                    ]),
                    _: 1
                  }, 8, ["tab"]),
                  _createVNode(_component_a_tab_pane, {
                    key: "2",
                    tab: _ctx.$t('common.concatTabs')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(TabsContacts, {
                        contactRefId: _unref(route).query.cosId,
                        appId: "cos_ofbu",
                        hideOk: true
                      }, null, 8, ["contactRefId"])
                    ]),
                    _: 1
                  }, 8, ["tab"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["title", "sellerName", "customLabel", "customValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})